module.exports = __webpack_public_path__ + "static/media/DomesticSexualViolence.cb76770e.svg";